import { css as t } from "@microsoft/fast-element";
import { normalize as a } from "../common/normalize.js";
import { display as s, PropertyStyleSheetBehavior as l } from "@matrix42/fast-foundation";
import { designTokens as r } from "../design-tokens.js";
import { typography as c } from "../styles/typography.js";
function i(e, n) {
  return new l("color", e, n);
}
function o(e) {
  return t`
    .control {
      /* Style */
      background-color: ${r.color[e][30]};
      color: ${r.color[e][100]};
    }

    .dispose-button:hover {
      /* Style */
      background-color: ${r.color[e][50]};
    }
  `;
}
const h = (e) => t`
    ${a}
    ${s("inline-flex")}
    :host {
      /* Base */
      vertical-align: middle;
    }

    .control {
      /* Base */
      cursor: default;
      min-height: calc(
        ${r.spacing[4]} + ${r.borderWidth.xs}
      );
      user-select: none;
      /* Layout */
      display: inline-flex;
      padding: 0 ${r.spacing[2]} 0 ${r.spacing[2]};
      justify-content: center;
      align-items: center;
      gap: ${r.spacing[1]};
      /* Style */
      border-radius: ${r.borderRadius.full};
    }

    .content {
      /* Base */
      vertical-align: middle;
      /* Typography */
      ${c("label", "semibold")}
    }

    .dispose-button {
      /* Base */
      cursor: pointer;
      min-height: ${r.spacing[4]};
      min-width: ${r.spacing[4]};
      /* Style */
      color: inherit;
      border-radius: ${r.borderRadius.full};
    }

    ::slotted(${e.prefix}-icon) {
      /* Layout */
      width: ${r.iconSize.xs} !important;
      height: ${r.iconSize.xs} !important;
      /* Style */
      color: inherit;
    }

    ::slotted(${e.prefix}-avatar) {
      /* Layout */
      width: ${r.spacing[4]} !important;
      height: ${r.spacing[4]} !important;
    }
  `.withBehaviors(
  i("primary", o("primary")),
  i("secondary", o("secondary")),
  i("neutral", o("neutral")),
  i("success", o("success")),
  i("warning", o("warning")),
  i("error", o("error"))
);
export {
  h as tagStyles
};
